import type { GetPermissionTagsParams } from '@vlabs/api/artemy/model/GetPermissionTagsParams';
import { createGenericFiltersContext } from '@vlabs/monokit/shared/lib';

const [
  usePermissionTagsFilters,
  PermissionTagsFiltersProvider,
] = createGenericFiltersContext<GetPermissionTagsParams>({
  displayName: 'PermissionTagsFilters',
});

export {
  usePermissionTagsFilters,
  PermissionTagsFiltersProvider,
};
